<template>
  <div 
    class="lds-ring"
    :style="{ width: `${size}px`, height: `${size}px` }"
  >
    <div :style="{
      'border-color': `${color} transparent transparent transparent`,
      width: `${size}px`, height: `${size}px`
    }"></div>
    <div :style="{
      'border-color': `${color} transparent transparent transparent`,
      width: `${size}px`, height: `${size}px`
    }"></div>
    <div :style="{
      'border-color': `${color} transparent transparent transparent`,
      width: `${size}px`, height: `${size}px`
    }"></div>
    <div :style="{
      'border-color': `${color} transparent transparent transparent`,
      width: `${size}px`, height: `${size}px`
    }"></div>
  </div>
</template>

<script>
export default {
  props: ['color', 'size']
}
</script>

<style lang="scss">
  .lds-ring {
    display: inline-block;
    position: relative;
  }
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    border: 6px solid;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
